import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@shared/components/ui/button';
import Tooltip from '@shared/components/ui/tooltip/tooltip';
import { useTranslation } from 'react-i18next';
import { AmazonFbmImportModal, AmazonFbmImportModalRef } from '../modals/AmazonFbmImportModal';

interface AmazonFbmImportButtonProps {
  shopId: number;
  onImportSuccess?: () => void;
}

export const AmazonFbmImportButton = ({ shopId, onImportSuccess }: AmazonFbmImportButtonProps) => {
  const { t } = useTranslation('shopsModule');
  const modalRef = useRef<AmazonFbmImportModalRef>(null);

  const handleClick = () => {
    modalRef.current?.open();
  };

  return (
    <>
      <Tooltip
        content={t('modals.amazonFbmImport.tooltip', {
          defaultValue: 'Importar pedidos desde archivo Amazon FBM',
        })}
        trigger={
          <Button variant="outline" size="sm" onClick={handleClick} data-testid="amazon-fbm-import-order-button">
            <FontAwesomeIcon icon={faFileImport} className="!w-3.5 !h-3.5 text-icons" />
          </Button>
        }
      />
      <AmazonFbmImportModal ref={modalRef} shopId={shopId} onSuccess={onImportSuccess} />
    </>
  );
};
